// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__2M5FA"};